module.exports = __webpack_public_path__ + "static/media/footer-linkedin.5c22b0e8.svg";